module.exports = __webpack_public_path__ + "static/media/paste.4e747d49.svg";